import React from "react";

interface BarcodeIconProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

const BarcodeIcon: React.FC<BarcodeIconProps> = ({ size = 28, className, onClick }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-label="Scan barcode"
    onClick={onClick}
    style={{ cursor: onClick ? "pointer" : undefined }}
  >
    <rect x="1" y="3" width="1.5" height="18" />
    <rect x="4" y="3" width="1" height="18" />
    <rect x="7" y="3" width="2" height="18" />
    <rect x="11" y="3" width="1" height="18" />
    <rect x="14" y="3" width="1.5" height="18" />
    <rect x="17" y="3" width="1" height="18" />
    <rect x="20" y="3" width="1.5" height="18" />
    <rect x="23" y="3" width="1" height="18" />
  </svg>
);

export default BarcodeIcon;
